(() => {
  if (window.LmcdOfferCheckout) return;
  window.LmcdOfferCheckout = true;

  const productSelector = '[data-lmcd-funnel-checkout]';
  const drawerSelector = 'theme-drawer#cart-drawer';
  const checkoutSelector = '[data-lmcd-phoenix-checkout], [data-lmcd-offer-cart-checkout], [data-lmcd-checkout-pending], [name="checkout"], #checkout';
  const offerFunnels = new Map([
    ['46487649779898', '1508'],
    ['46584039375034', '1509'],
    ['46584039440570', '1510'],
    ['50529807925434', '1746'],
    ['50529864417466', '1747'],
    ['46584039309498', '1511'],
    ['46584039407802', '1512'],
    ['46742680207546', '1733'],
    ['46742691348666', '1734'],
    ['46742699999418', '1735'],
    ['46742704029882', '1736'],
  ]);
  const submitSelector = 'button:not([type]), button[type="submit"], input[type="submit"], input[type="image"]';
  const route = path => `${(window.Shopify?.routes?.root || '/').replace(/\/$/, '')}${path}`;
  const quantity = form => Math.max(1, Number.parseInt(form.querySelector('[name="quantity"]')?.value, 10) || 1);
  const drawer = () => document.querySelector(drawerSelector);
  let invalidatedDrawerObserver;
  let cartResponseRevision = 0;
  let pendingResponseId = null;

  const invalidateDrawer = () => {
    const target = drawer();
    if (!target) return;
    pendingResponseId = null;
    target.dataset.lmcdCartInvalidated = 'true';
    const disableStaleContent = () => {
      if (pendingResponseId && target.querySelector('.cart-drawer__inner')?.dataset.lmcdCartResponse === pendingResponseId) return;
      target.querySelectorAll('.lmcd-offer-cart-drawer__item').forEach(row => {
        if (!row.inert) row.inert = true;
        if (row.getAttribute('aria-disabled') !== 'true') row.setAttribute('aria-disabled', 'true');
      });
      target.querySelectorAll(checkoutSelector).forEach(control => {
        if (control.dataset.lmcdCheckoutPending !== 'true') control.dataset.lmcdCheckoutPending = 'true';
        if (control.getAttribute('aria-disabled') !== 'true') control.setAttribute('aria-disabled', 'true');
        if (control.getAttribute('tabindex') !== '-1') control.setAttribute('tabindex', '-1');
        if (control.hasAttribute('href')) control.removeAttribute('href');
        if ('disabled' in control && !control.disabled) control.disabled = true;
      });
    };
    invalidatedDrawerObserver?.disconnect();
    disableStaleContent();
    invalidatedDrawerObserver = new MutationObserver(disableStaleContent);
    invalidatedDrawerObserver.observe(target, { childList: true, subtree: true, attributes: true });
  };

  const allowDrawerHydration = () => {
    invalidatedDrawerObserver?.disconnect();
    pendingResponseId = null;
    drawer()?.removeAttribute('data-lmcd-cart-invalidated');
  };

  document.addEventListener('click', event => {
    const control = event.target instanceof Element ? event.target.closest(checkoutSelector) : null;
    if (!control?.closest(`${drawerSelector}[data-lmcd-cart-invalidated]`)) return;
    event.preventDefault(); event.stopImmediatePropagation();
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest(`${drawerSelector}[data-lmcd-cart-invalidated]`)) return;
    if (form.id !== 'cart-form' && !event.submitter?.matches(checkoutSelector)) return;
    event.preventDefault(); event.stopImmediatePropagation();
  }, true);

  const parseResponse = async response => {
    const text = await response.text();
    let data;
    try { data = text ? JSON.parse(text) : {}; }
    catch { throw new Error('Cart update failed. Please try again.'); }
    if (!response.ok || data.status || data.errors) throw new Error(data.description || data.message || data.errors || 'Cart update failed. Please try again.');
    return data;
  };

  const clearCart = () => fetch(route('/cart/clear.js'), {
    method: 'POST',
    credentials: 'same-origin',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: '{}',
  }).then(parseResponse);

  const sectionIds = () => {
    const ids = new Set(['cart-drawer-section']);
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(node => {
      if (node instanceof HTMLElement && node.dataset.sectionId) ids.add(node.dataset.sectionId);
    });
    return [...ids].join(',');
  };

  const addCartItem = (form, variantId, itemQuantity) => {
    const body = new FormData(form);
    body.set('id', variantId);
    body.set('quantity', String(itemQuantity));
    body.set('sections', sectionIds());
    body.set('sections_url', `${location.pathname}${location.search}`);
    return fetch(route('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
      body,
    }).then(parseResponse);
  };

  const checkoutMatches = (scope, variantId, itemQuantity) => {
    const funnel = offerFunnels.get(variantId);
    if (funnel) {
      const link = scope.querySelector('[data-lmcd-offer-cart-checkout]');
      return link?.dataset.lmcdVariantId === variantId
        && link.dataset.lmcdFunnelId === funnel
        && link.dataset.lmcdQuantity === String(itemQuantity)
        && link.hasAttribute('href')
        && link.getAttribute('aria-disabled') !== 'true';
    }
    const pending = scope.querySelector('[data-lmcd-checkout-pending="true"]');
    return pending?.getAttribute('aria-disabled') === 'true' && pending.disabled === true;
  };

  const cartMatches = (scope, variantId, itemQuantity) => {
    const rows = [...scope.querySelectorAll('.lmcd-offer-cart-drawer__item[data-variant-id]')];
    return rows.length === 1
      && rows[0].dataset.variantId === variantId
      && (rows[0].querySelector('[name="updates[]"]')?.value || '1') === String(itemQuantity)
      && checkoutMatches(scope, variantId, itemQuantity);
  };

  const sectionDocument = (html, variantId, itemQuantity) => {
    if (typeof html !== 'string' || !html.trim()) throw new Error('Cart display could not be loaded. Please try again.');
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    if (!parsed.querySelector('.cart-drawer__inner') || !cartMatches(parsed, variantId, itemQuantity)) throw new Error('Cart update did not match this item. Please try again.');
    return parsed;
  };

  const waitForDrawerHydration = (variantId, itemQuantity, responseId) => new Promise((resolve, reject) => {
    const consumed = () => drawer()?.querySelector('.cart-drawer__inner')?.dataset.lmcdCartResponse === responseId
      && cartMatches(drawer(), variantId, itemQuantity);
    if (consumed()) return resolve();
    const observer = new MutationObserver(() => {
      if (!consumed()) return;
      clearTimeout(timeout); observer.disconnect(); resolve();
    });
    const timeout = setTimeout(() => { observer.disconnect(); reject(new Error('Cart display could not be loaded. Please try again.')); }, 7000);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true });
  });

  const dispatchCartUpdate = (product, response, variantId, itemQuantity) => {
    const items = Array.isArray(response.items) ? response.items : [response];
    const detail = { sections: response.sections || {}, items, itemCount: itemQuantity, source: 'lmcd-offer-checkout', didError: false };
    const cart = { totalQuantity: itemQuantity, lines: [{ merchandiseId: variantId, quantity: itemQuantity }] };
    const settlement = { itemCount: itemQuantity, sections: detail.sections };
    Object.defineProperties(settlement, { cart: { value: cart }, detail: { value: detail } });
    const event = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
    Object.assign(event, { action: 'update', context: 'product', lines: cart.lines, promise: Promise.resolve(settlement) });
    product.dispatchEvent(event);
  };

  const openCart = async () => {
    const target = drawer();
    if (!target) throw new Error('Cart is unavailable. Please try again.');
    await customElements.whenDefined('theme-drawer');
    if (typeof window.Shopify?.actions?.openCart === 'function') window.Shopify.actions.openCart();
    else target.open?.();
  };

  const renderError = (form, error) => {
    let alert = form.parentElement?.querySelector('[data-lmcd-checkout-error]');
    if (!alert) {
      alert = document.createElement('div');
      alert.dataset.lmcdCheckoutError = 'true';
      alert.setAttribute('role', 'alert');
      alert.setAttribute('aria-live', 'polite');
      form.insertAdjacentElement('afterend', alert);
    }
    alert.textContent = error instanceof Error ? error.message : 'Cart update failed. Please try again.';
  };

  const replaceCart = async (product, form, variantId, itemQuantity) => {
    drawer()?.close?.();
    await clearCart();
    invalidateDrawer();
    try {
      const response = await addCartItem(form, variantId, itemQuantity);
      const parsed = sectionDocument(response.sections?.['cart-drawer-section'], variantId, itemQuantity);
      const responseId = String(++cartResponseRevision);
      // Horizon morphs attributes and children of this hydration root. The marker
      // exists only in the dispatched response until that response is consumed.
      parsed.querySelector('.cart-drawer__inner').dataset.lmcdCartResponse = responseId;
      response.sections['cart-drawer-section'] = parsed.body.innerHTML;
      pendingResponseId = responseId;
      dispatchCartUpdate(product, response, variantId, itemQuantity);
      await waitForDrawerHydration(variantId, itemQuantity, responseId);
      allowDrawerHydration();
      await openCart();
    } catch (error) {
      invalidateDrawer();
      try { await clearCart(); } catch { /* best-effort cleanup */ }
      throw error;
    }
  };

  const bind = product => {
    if (product.dataset.lmcdFunnelBound === 'true') return;
    product.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.dataset.lmcdCheckoutBound = 'true';
      form.addEventListener('submit', event => {
        const variantId = form.querySelector('[name="id"]')?.value || '';
        if (!offerFunnels.has(variantId)) return;
        event.preventDefault(); event.stopImmediatePropagation();
        if (form.dataset.lmcdCheckoutSubmitting === 'true') return;
        form.dataset.lmcdCheckoutSubmitting = 'true';
        const controls = [...form.querySelectorAll(submitSelector)].map(control => ({ control, disabled: control.disabled }));
        form.setAttribute('aria-busy', 'true'); controls.forEach(({ control }) => { control.disabled = true; });
        form.parentElement?.querySelector('[data-lmcd-checkout-error]')?.remove();
        replaceCart(product, form, variantId, quantity(form))
          .catch(error => renderError(form, error))
          .finally(() => {
            delete form.dataset.lmcdCheckoutSubmitting; form.removeAttribute('aria-busy');
            controls.forEach(({ control, disabled }) => { control.disabled = disabled; });
          });
      }, { capture: true });
    });
    product.dataset.lmcdFunnelBound = 'true';
  };

  const bindAll = (root = document) => {
    if (root.matches?.(productSelector)) bind(root);
    root.querySelectorAll?.(productSelector).forEach(bind);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindAll(), { once: true });
  else bindAll();
  document.addEventListener('shopify:section:load', event => bindAll(event.target));
})();
